import styled from 'styled-components';

export const PageContainer = styled.div`
  position: relative;
  transition:
    min-width 500ms,
    max-width 500ms;
  width: -webkit-fill-available;
  min-height: calc(100vh - 195px);
  max-height: calc(100vh - 195px);
  margin: 0 2rem;
  background-color: #ececec;
  border-radius: 10px;
  overflow: hidden;
  padding: 2rem;
`;

export const TabContainer = styled.div`
  padding: 2rem 1rem;
`;
